// Constants
import { StoreEntityState } from "@ms/uno-constants/lib/local/StoreConstants";
// Controls
import { Button, Link } from "@fluentui/react-components";
import { ErrorView } from "../errorView/ErrorView";
// Resources
import documentExclamLight from "@ms/uno-resources/lib/local/images/document-exclamation-light.png";
import documentExclamDark from "@ms/uno-resources/lib/local/images/document-exclamation-dark.png";
import trashLight from "@ms/uno-resources/lib/local/images/trashFullLight.png";
import trashDark from "@ms/uno-resources/lib/local/images/trashFullDark.png";
import personCircleDismissLight from "@ms/uno-resources/lib/local/images/person-circle-dismiss-light.png";
import personCircleDismissDark from "@ms/uno-resources/lib/local/images/person-circle-dismiss-dark.png";
// Utilities
import { Strings } from "@ms/uno-resources/lib/local/CultureUtilities";
import * as React from "react";
/**
 * Unified plan error view component
 */ export const PlanErrorView = ({ isTeamsTabView, isMyPlansPlan, planStatus, navigateToMyPlansButtonCallback, removePlanFromMyPlans, retryCallback })=>{
    // Set the image and error message based on the plan status
    let imageDark;
    let imageLight;
    let errorText;
    let errorSubText;
    switch(planStatus){
        case StoreEntityState.NotFound:
            errorText = Strings.Errors_EvoPlanNotFoundErrorText;
            errorSubText = /*#__PURE__*/ React.createElement(React.Fragment, null, Strings.Errors_PlanNotFoundRestoreGroupText, " ", /*#__PURE__*/ React.createElement(Link, {
                "data-testid": "plan-error-view-link",
                href: "https://outlook.office.com/groups/",
                target: "_blank",
                inline: true,
                rel: "noreferrer"
            }, Strings.Errors_PlanNotFoundViewGroupsLinkText));
            imageLight = trashLight;
            imageDark = trashDark;
            break;
        case StoreEntityState.Inaccessible:
            errorText = Strings.Errors_PlanInaccessibleErrorText;
            errorSubText = Strings.Errors_EvoPlanInaccessibleErrorBody;
            imageLight = personCircleDismissLight;
            imageDark = personCircleDismissDark;
            break;
        case StoreEntityState.UnableToFetch:
        default:
            errorText = Strings.Errors_EvoPlanGenericErrorText;
            errorSubText = planStatus === StoreEntityState.UnableToFetch ? Strings.Errors_PlanUnableToFetchErrorBody : Strings.Errors_PlanGenericErrorBody;
            imageLight = documentExclamLight;
            imageDark = documentExclamDark;
            break;
    }
    // Create primary and secondary buttons for ErrorView
    let primaryButton;
    let secondaryButton;
    switch(planStatus){
        case StoreEntityState.Inaccessible:
            primaryButton = !isTeamsTabView ? /*#__PURE__*/ React.createElement(Button, {
                "data-testid": "plan-error-view-go-to-my-plans-button",
                appearance: "primary",
                onClick: navigateToMyPlansButtonCallback
            }, Strings.Errors_PlanGoToMyPlansButtonText) : undefined;
            break;
        case StoreEntityState.NotFound:
            if (isTeamsTabView) {
                primaryButton = undefined;
            } else if (isMyPlansPlan) {
                primaryButton = /*#__PURE__*/ React.createElement(Button, {
                    "data-testid": "plan-error-view-remove-from-my-plans-button",
                    appearance: "primary",
                    onClick: removePlanFromMyPlans
                }, Strings.Errors_PlanRemoveFromMyPlansButtonText);
            } else {
                primaryButton = /*#__PURE__*/ React.createElement(Button, {
                    "data-testid": "plan-error-view-go-to-my-plans-button",
                    appearance: "primary",
                    onClick: navigateToMyPlansButtonCallback
                }, Strings.Errors_PlanGoToMyPlansButtonText);
            }
            break;
        case StoreEntityState.UnableToFetch:
        default:
            primaryButton = !isTeamsTabView ? /*#__PURE__*/ React.createElement(Button, {
                "data-testid": "plan-error-view-retry-button",
                appearance: "primary",
                onClick: retryCallback
            }, Strings.Notifications_RetryButtonText) : undefined;
            secondaryButton = !isTeamsTabView ? /*#__PURE__*/ React.createElement(Button, {
                "data-testid": "plan-error-view-go-to-my-plans-button",
                appearance: "secondary",
                onClick: navigateToMyPlansButtonCallback
            }, Strings.Errors_PlanGoToMyPlansButtonText) : undefined;
            break;
    }
    return /*#__PURE__*/ React.createElement(ErrorView, {
        dataTestId: "plan-error-view",
        imageDark: imageDark,
        imageLight: imageLight,
        errorText: errorText,
        errorSubText: errorSubText,
        primaryButton: primaryButton,
        secondaryButton: secondaryButton
    });
};
